import styled, { css } from 'styled-components';
import { BreakPoint } from '@makemydeal/dr-activities-common';
import { Box } from '@interstate/components/Box';
import { Grid } from '@interstate/components/Grid';
import { Typography } from '@interstate/components/Typography';

export const FunctionsFooterContainer = styled(Box)`
    display: flex;
    justify-content: flex-end;
    margin-right: 2rem;
    margin-bottom: 2rem;

    @media (max-width: ${BreakPoint.PHONE}) {
        margin: 0;
        padding: 0.5rem 1rem;

        border-top: 0.0625rem solid #b2b2b2;
        background-color: #f4f4f4f5;
        .functions-ok-button {
            width: 95vw;
        }
    }
`;

export const FunctionsRowItemContainer = styled(Grid)<{ showLeft: boolean; title: string; noMarginBottom: boolean }>`
    flex: 1;

    ${({ showLeft, title, noMarginBottom }) => css`
        margin-right: ${showLeft ? '1.25rem' : 0};
        margin-left: ${!showLeft ? '1.25rem' : 0};
        margin-bottom: 0;
        margin-top: ${!showLeft && !title ? '2.3125rem' : 0};

        @media (max-width: ${BreakPoint.PHONE}) {
            margin-right: 0;
            margin-left: 0;
            margin-bottom: ${showLeft && title && !noMarginBottom ? '1.125rem' : 0};
            margin-top: 0;
        }
    `}
`;

export const FunctionsLinkContainer = styled(Typography)`
    display: flex;
    flex-direction: row;
    gap: 0.4rem;
    align-items: center;
    white-space: nowrap;
    margin-top: 0.125rem !important;
`;

export const FunctionsRowContainer = styled(Grid)`
    display: flex;
    flex-direction: row;
    margin-bottom: 1.125rem;

    @media (max-width: ${BreakPoint.PHONE}) {
        flex-direction: column;
    }
`;
